import React, { useEffect } from "react";
import EnquiryForm from "../components/EnquiryForm";
import { COMPANY } from "../data/site";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Contact — Weldmatix Fusion";
  }, []);

  return (
    <div data-testid="page-contact" className="bg-[#FFFFFF] pt-32 md:pt-40">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-16">
        <div className="eyebrow mb-4">// Contact</div>
        <h1 className="font-display uppercase tracking-tight text-slate-900 text-5xl md:text-7xl leading-[0.95]">
          Let's build<br /><span className="text-[#0EA5E9]">something critical.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-[#475569] leading-relaxed">
          Reach our engineering and sales team for system enquiries, custom automation
          requests, service & spares, or project consultations.
        </p>
      </section>

      <section className="border-t border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4 space-y-8">
            {[
              { icon: Mail, label: "Sales", value: COMPANY.email_sales, href: `mailto:${COMPANY.email_sales}` },
              { icon: Mail, label: "General", value: COMPANY.email_info, href: `mailto:${COMPANY.email_info}` },
              { icon: Phone, label: "WhatsApp", value: COMPANY.whatsapp, href: COMPANY.whatsapp_link },
              { icon: MapPin, label: "Operations", value: "Global OEM Manufacturing" }
            ].map((c) => (
              <div key={c.label} data-testid={`contact-${c.label.toLowerCase()}`} className="border border-[#E2E8F0] bg-[#F8FAFC] p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 border border-[#E2E8F0] flex items-center justify-center text-[#0EA5E9]">
                    <c.icon className="w-4 h-4" />
                  </div>
                  <div className="font-mono-wm text-[10px] tracking-[0.3em] uppercase text-[#64748B]">{c.label}</div>
                </div>
                {c.href ? (
                  <a href={c.href} className="text-slate-900 text-base hover:text-[#0EA5E9] flex items-center gap-2">
                    {c.value} <ArrowUpRight className="w-4 h-4" />
                  </a>
                ) : (
                  <div className="text-slate-900 text-base">{c.value}</div>
                )}
              </div>
            ))}
          </div>
          <div className="md:col-span-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}
